'use strict';

export const isNumericBarcode = (barcode) => {
    return /^[0-9]+$/.test(barcode);
};

export const validateBarcodeLength = (barcode) => {
    const trimmedBarcode = barcode.replace(/^0+/, '');
    return trimmedBarcode.length <= 14;
};